/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import * as Sentry from "@sentry/react";
import { Capacitor } from "@capacitor/core";

export function captureException(error: Error, context?: Record<string, unknown>) {
  if (import.meta.env.DEV) {
    console.error("[errorLogger] captureException:", error, context);
  }
  Sentry.captureException(error, context ? { extra: context } : undefined);
}

export function logUserAction(action: string, data?: Record<string, unknown>) {
  Sentry.addBreadcrumb({
    category: "user-action",
    message: action,
    data,
    level: "info",
  });

  if (Capacitor.isNativePlatform()) {
    import("@/utils/crashlytics").then(({ logCrash }) => {
      const stringData: Record<string, string> = {};
      if (data) {
        for (const [k, v] of Object.entries(data)) {
          stringData[k] = String(v);
        }
      }
      logCrash(action, stringData);
    }).catch(() => {});
  }
}
